// tagging.types.js
import PropTypes from "prop-types";

/**
 * GET /project_tag_values – Response shape
 * @typedef {Object} ProjectTagValuesRow
 * @property {number} project_id
 * @property {number} tag_id
 * @property {string} tag_slug
 * @property {0|1} multi_value
 * @property {number[]} tag_value_ids
 *
 * @typedef {ProjectTagValuesRow[]} ProjectTagValuesResponse
*/

/**
 * DELETE /project_tag_values –Delete a project tag value
 *
 * @typedef {Object} TagValueDeleteRequest
 * @property {number} project_id
 * @property {number} tag_value_id
 */

/**
 * POST /project_tag_values –Add a tag value to a project
 * @typedef {Object} TagValueAddRequest
 * @property {number} project_id
 * @property {number} tag_value_id
 */

/**
 * @typedef {TagValueAddRequest | TagValueDeleteRequest} TagValueRequest
 */

/**
 * DELETE /project_tag_values – Response shape
 * @typedef {Object} TagValueDeleteResponse
 * @property {string} updateTime - Timestamp of when the project tag value was last updated.
 * @property {number} deletedRows - Number of rows deleted (should be 1 if successful).
 */

/**
 * POST /project_tag_values – Response shape
 * @typedef {Object} TagValueAddResponse
 * @property {string} updateTime - Timestamp of when the project tag value was last updated.
 */

/**
 * @typedef {TagValueAddResponse | TagValueDeleteResponse} TagValueResponse
 */

/**
 * @typedef {Object} OrganisationTagValue
 * @property {number} tag_value_id       - Tag value row id.
 * @property {string} title              - Tag value title.
 * @property {number} order_by           - Order for display within the tag.
 */

/**
 * @typedef {Object} OrganisationTag
 * @property {number} tag_id             - Tag row id.
 * @property {string} tag_slug           - Unique slug for the tag within the org.
 * @property {string} tag_title          - Tag title.
 * @property {boolean} multi_value         - If true, multiple values can be assigned to a project.
 * @property {boolean} is_groupable         - If true, tag can be used to group projects in lists.
 * @property {boolean} is_filter            - If true, tag can be used to filter projects in lists.
 * @property {number} tag_order_by        - Order for display among other tags.
 * @property {OrganisationTagValue[]} tag_values - Array of tag values associated with this tag.
*/

export const OrganisationTagValuePropType = PropTypes.shape({
  tag_value_id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  order_by: PropTypes.number.isRequired,
});

export const OrganisationTagPropType = PropTypes.shape({
  tag_id: PropTypes.number.isRequired,
  tag_slug: PropTypes.string.isRequired,
  tag_title: PropTypes.string.isRequired,
  multi_value: PropTypes.bool.isRequired,
  is_groupable: PropTypes.bool.isRequired,
  is_filter: PropTypes.bool.isRequired,
  tag_order_by: PropTypes.number.isRequired,
  tag_values: PropTypes.arrayOf(OrganisationTagValuePropType).isRequired,
});